import React, { useCallback } from 'react';
import { Box } from '@material-ui/core';
import { useField } from 'formik';
import { Autocomplete } from '../Autocomplete';

export const FormAutocompleteField = ({
  label,
  name,
  options,
  icon,
  placeholder,
  fullWidth,
  className,
  onBlur,
  readOnly,
}) => {
  const [{ value }, meta, helpers] = useField(name);

  const handleBlur = useCallback(
    (fieldOnBlur) => (e) => {
      fieldOnBlur(e);
      if (onBlur) {
        onBlur(e);
      }
    },
    [onBlur]
  );

  return (
    <Box className={className}>
      <Autocomplete
        name={name}
        options={options}
        icon={icon}
        fullWidth={fullWidth}
        placeholder={placeholder}
        onBlur={handleBlur}
        onChange={(value) => {
          helpers.setValue(value);
        }}
        disabled={readOnly}
        readOnly={readOnly}
        defaultValue={value}
        error={!!meta.error}
        helperText={meta.error}
        label={label}
      />
    </Box>
  );
};
